import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["defaultButtons", "searchBar", "searchInput", "searchCounter"];

  connect() {
    const panel = this.element.closest("[data-controller~='qc-preview-panel']");
    if (panel) {
      this._panel = panel;
      this._onSearchUpdate = (e) => {
        this.searchCounterTarget.textContent = `${e.detail.current}/${e.detail.total}`;
      };
      panel.addEventListener("qc-pdf:searchUpdate", this._onSearchUpdate);
    }
  }

  disconnect() {
    this._panel?.removeEventListener("qc-pdf:searchUpdate", this._onSearchUpdate);
  }

  openSearch() {
    this.defaultButtonsTarget.classList.add("hidden");
    this.defaultButtonsTarget.classList.remove("flex");
    this.searchBarTarget.classList.remove("hidden");
    this.searchBarTarget.classList.add("flex");
    this.searchInputTarget.focus();
  }

  closeSearch() {
    this.searchBarTarget.classList.add("hidden");
    this.searchBarTarget.classList.remove("flex");
    this.defaultButtonsTarget.classList.remove("hidden");
    this.defaultButtonsTarget.classList.add("flex");
    this.searchInputTarget.value = "";
    this.searchCounterTarget.textContent = "0/0";
    this._lastSearchedQuery = null;
    this._dispatch("qc-pdf:clearSearch");
  }

  fitToWidth() {
    this._dispatch("qc-pdf:fitToWidth");
  }

  download() {
    this._dispatch("qc-pdf:download");
  }

  performSearch() {
    const query = this.searchInputTarget.value.trim();
    if (query) {
      this._lastSearchedQuery = query;
      this._dispatch("qc-pdf:search", { query });
    }
  }

  prevMatch() {
    this._dispatch("qc-pdf:findPrevious");
  }

  nextMatch() {
    this._dispatch("qc-pdf:findNext");
  }

  onSearchKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      const query = this.searchInputTarget.value.trim();
      if (query && query === this._lastSearchedQuery) {
        this.nextMatch();
      } else {
        this.performSearch();
      }
    }
    if (event.key === "Escape") {
      this.closeSearch();
    }
  }

  _dispatch(name, detail = {}) {
    this.element.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
  }
}
